const moduleNameKey = "dashboardThemeEditor";

export const dashboardThemeEditorEn = {
  [moduleNameKey]: {
    resetPalette: "Default colors",
    editorTitle: "Customize Dashboard color palette",
    brushTooltip: "Customize colors",
    hexModeCheckbox: "Type HEX manually",
    closeAriaLabel: "Close palette editor",
    swatchLabels: {
      // Picker order is dashboard chrome → text → widget surface → widget text.
      // Internal keys stay snake_case; only the user-facing labels change so
      // the BE wire is unchanged.
      canvasBg: "Dashboard background",
      subheaderBg: "Dashboard Header",
      textPrimary: "Dashboard Primary text",
      textSecondary: "Dashboard Secondary text",
      widgetsBg: "Widget background",
      border: "Widget border",
      borderHover: "Widget border hover",
      widgetTitle: "Widget title",
      widgetPrimary: "Widget primary text",
      widgetSecondary: "Widget secondary text",
    },
    swatchDescriptions: {
      canvasBg: "Dashboard background color",
      subheaderBg: "Dashboard header background color",
      textPrimary: "Dashboard primary text color",
      textSecondary: "Dashboard secondary text color",
      widgetsBg: "Widget background color",
      border: "Widget border color",
      borderHover: "Widget border color on hover",
      widgetTitle: "Widget title text color",
      widgetPrimary: "Widget primary text color",
      widgetSecondary: "Widget secondary text color",
    },
    popoverTitles: {
      canvasBg: "Choose dashboard background",
      subheaderBg: "Choose dashboard header",
      textPrimary: "Choose dashboard primary text",
      textSecondary: "Choose dashboard secondary text",
      widgetsBg: "Choose widget background",
      border: "Choose widget border",
      borderHover: "Choose widget border on hover",
      widgetTitle: "Choose widget title",
      widgetPrimary: "Choose widget primary text",
      widgetSecondary: "Choose widget secondary text",
    },
  },
};

export const dashboardThemeEditorPtBr = {
  [moduleNameKey]: {
    resetPalette: "Cores padrão",
    editorTitle: "Personalizar paleta de cores do painel",
    brushTooltip: "Personalizar paleta",
    hexModeCheckbox: "Digitar HEX manualmente",
    closeAriaLabel: "Fechar editor de paleta",
    swatchLabels: {
      canvasBg: "Fundo do painel",
      subheaderBg: "Cabeçalho do painel",
      textPrimary: "Texto primário do painel",
      textSecondary: "Texto secundário do painel",
      widgetsBg: "Fundo do widget",
      border: "Borda do widget",
      borderHover: "Borda do widget ao passar",
      widgetTitle: "Título do widget",
      widgetPrimary: "Texto primário do widget",
      widgetSecondary: "Texto secundário do widget",
    },
    swatchDescriptions: {
      canvasBg: "Cor de fundo do painel",
      subheaderBg: "Cor de fundo do cabeçalho do painel",
      textPrimary: "Cor do texto primário do painel",
      textSecondary: "Cor do texto secundário do painel",
      widgetsBg: "Cor de fundo do widget",
      border: "Cor da borda do widget",
      borderHover: "Cor da borda do widget ao passar",
      widgetTitle: "Cor do título do widget",
      widgetPrimary: "Cor do texto primário do widget",
      widgetSecondary: "Cor do texto secundário do widget",
    },
    popoverTitles: {
      canvasBg: "Escolher fundo do painel",
      subheaderBg: "Escolher cabeçalho do painel",
      textPrimary: "Escolher texto primário do painel",
      textSecondary: "Escolher texto secundário do painel",
      widgetsBg: "Escolher fundo do widget",
      border: "Escolher borda do widget",
      borderHover: "Escolher borda do widget ao passar",
      widgetTitle: "Escolher título do widget",
      widgetPrimary: "Escolher texto primário do widget",
      widgetSecondary: "Escolher texto secundário do widget",
    },
  },
};

export const dashboardThemeEditorDe = {
  [moduleNameKey]: {
    resetPalette: "Standardfarben",
    editorTitle: "Dashboard-Farbpalette anpassen",
    brushTooltip: "Palette anpassen",
    hexModeCheckbox: "HEX manuell eingeben",
    closeAriaLabel: "Paletten-Editor schließen",
    swatchLabels: {
      canvasBg: "Dashboard-Hintergrund",
      subheaderBg: "Dashboard-Kopfzeile",
      textPrimary: "Dashboard-Primärtext",
      textSecondary: "Dashboard-Sekundärtext",
      widgetsBg: "Widget-Hintergrund",
      border: "Widget-Rahmen",
      borderHover: "Widget-Rahmen beim Überfahren",
      widgetTitle: "Widget-Titel",
      widgetPrimary: "Widget-Primärtext",
      widgetSecondary: "Widget-Sekundärtext",
    },
    swatchDescriptions: {
      canvasBg: "Dashboard-Hintergrundfarbe",
      subheaderBg: "Hintergrundfarbe der Dashboard-Kopfzeile",
      textPrimary: "Primärtextfarbe des Dashboards",
      textSecondary: "Sekundärtextfarbe des Dashboards",
      widgetsBg: "Widget-Hintergrundfarbe",
      border: "Widget-Rahmenfarbe",
      borderHover: "Widget-Rahmenfarbe beim Überfahren",
      widgetTitle: "Widget-Titelfarbe",
      widgetPrimary: "Widget-Primärtextfarbe",
      widgetSecondary: "Widget-Sekundärtextfarbe",
    },
    popoverTitles: {
      canvasBg: "Dashboard-Hintergrund wählen",
      subheaderBg: "Dashboard-Kopfzeile wählen",
      textPrimary: "Dashboard-Primärtext wählen",
      textSecondary: "Dashboard-Sekundärtext wählen",
      widgetsBg: "Widget-Hintergrund wählen",
      border: "Widget-Rahmen wählen",
      borderHover: "Widget-Rahmenfarbe beim Überfahren wählen",
      widgetTitle: "Widget-Titel wählen",
      widgetPrimary: "Widget-Primärtext wählen",
      widgetSecondary: "Widget-Sekundärtext wählen",
    },
  },
};

export const dashboardThemeEditorZhHans = {
  [moduleNameKey]: {
    resetPalette: "重置配色",
    editorTitle: "自定义仪表板配色",
    brushTooltip: "自定义配色",
    hexModeCheckbox: "手动输入 HEX",
    closeAriaLabel: "关闭配色编辑器",
    swatchLabels: {
      canvasBg: "仪表板背景",
      subheaderBg: "仪表板页眉",
      textPrimary: "仪表板主要文本",
      textSecondary: "仪表板次要文本",
      widgetsBg: "小部件背景",
      border: "小部件边框",
      borderHover: "小部件边框悬停",
      widgetTitle: "小部件标题",
      widgetPrimary: "小部件主要文本",
      widgetSecondary: "小部件次要文本",
    },
    swatchDescriptions: {
      canvasBg: "仪表板背景颜色",
      subheaderBg: "仪表板页眉背景颜色",
      textPrimary: "仪表板主要文本颜色",
      textSecondary: "仪表板次要文本颜色",
      widgetsBg: "小部件背景颜色",
      border: "小部件边框颜色",
      borderHover: "小部件悬停时边框颜色",
      widgetTitle: "小部件标题颜色",
      widgetPrimary: "小部件主要文本颜色（值、标签、单位、图表提示）",
      widgetSecondary: "小部件次要文本颜色（时间戳、坐标轴标签）",
    },
    popoverTitles: {
      canvasBg: "选择仪表板背景",
      subheaderBg: "选择仪表板页眉",
      textPrimary: "选择仪表板主要文本",
      textSecondary: "选择仪表板次要文本",
      widgetsBg: "选择小部件背景",
      border: "选择小部件边框",
      borderHover: "选择小部件边框悬停",
      widgetTitle: "选择小部件标题",
      widgetPrimary: "选择小部件主要文本",
      widgetSecondary: "选择小部件次要文本",
    },
  },
};

export const dashboardThemeEditorIt = {
  [moduleNameKey]: {
    resetPalette: "Colori predefiniti",
    editorTitle: "Personalizza palette di colori della dashboard",
    brushTooltip: "Personalizza palette",
    hexModeCheckbox: "Digita HEX manualmente",
    closeAriaLabel: "Chiudi editor palette",
    swatchLabels: {
      canvasBg: "Sfondo dashboard",
      subheaderBg: "Intestazione dashboard",
      textPrimary: "Testo primario dashboard",
      textSecondary: "Testo secondario dashboard",
      widgetsBg: "Sfondo widget",
      border: "Bordo widget",
      borderHover: "Bordo widget al passaggio",
      widgetTitle: "Titolo widget",
      widgetPrimary: "Testo primario widget",
      widgetSecondary: "Testo secondario widget",
    },
    swatchDescriptions: {
      canvasBg: "Colore sfondo dashboard",
      subheaderBg: "Colore sfondo intestazione dashboard",
      textPrimary: "Colore testo primario dashboard",
      textSecondary: "Colore testo secondario dashboard",
      widgetsBg: "Colore sfondo widget",
      border: "Colore bordo widget",
      borderHover: "Colore bordo widget al passaggio",
      widgetTitle: "Colore titolo widget",
      widgetPrimary: "Colore testo primario widget",
      widgetSecondary: "Colore testo secondario widget",
    },
    popoverTitles: {
      canvasBg: "Scegli sfondo dashboard",
      subheaderBg: "Scegli intestazione dashboard",
      textPrimary: "Scegli testo primario dashboard",
      textSecondary: "Scegli testo secondario dashboard",
      widgetsBg: "Scegli sfondo widget",
      border: "Scegli bordo widget",
      borderHover: "Scegli bordo widget al passaggio",
      widgetTitle: "Scegli titolo widget",
      widgetPrimary: "Scegli testo primario widget",
      widgetSecondary: "Scegli testo secondario widget",
    },
  },
};

export const dashboardThemeEditorEs = {
  [moduleNameKey]: {
    resetPalette: "Colores predeterminados",
    editorTitle: "Personalizar paleta de colores del panel",
    brushTooltip: "Personalizar paleta",
    hexModeCheckbox: "Escribir HEX manualmente",
    closeAriaLabel: "Cerrar editor de paleta",
    swatchLabels: {
      canvasBg: "Fondo del panel",
      subheaderBg: "Encabezado del panel",
      textPrimary: "Texto principal del panel",
      textSecondary: "Texto secundario del panel",
      widgetsBg: "Fondo del widget",
      border: "Borde del widget",
      borderHover: "Borde del widget al pasar",
      widgetTitle: "Título del widget",
      widgetPrimary: "Texto principal del widget",
      widgetSecondary: "Texto secundario del widget",
    },
    swatchDescriptions: {
      canvasBg: "Color de fondo del panel",
      subheaderBg: "Color de fondo del encabezado del panel",
      textPrimary: "Color de texto principal del panel",
      textSecondary: "Color de texto secundario del panel",
      widgetsBg: "Color de fondo del widget",
      border: "Color de borde del widget",
      borderHover: "Color de borde del widget al pasar",
      widgetTitle: "Color de título del widget",
      widgetPrimary: "Color de texto principal del widget",
      widgetSecondary: "Color de texto secundario del widget",
    },
    popoverTitles: {
      canvasBg: "Elegir fondo del panel",
      subheaderBg: "Elegir encabezado del panel",
      textPrimary: "Elegir texto principal del panel",
      textSecondary: "Elegir texto secundario del panel",
      widgetsBg: "Elegir fondo del widget",
      border: "Elegir borde del widget",
      borderHover: "Elegir borde del widget al pasar",
      widgetTitle: "Elegir título del widget",
      widgetPrimary: "Elegir texto principal del widget",
      widgetSecondary: "Elegir texto secundario del widget",
    },
  },
};

export const dashboardThemeEditorNl = {
  [moduleNameKey]: {
    resetPalette: "Standaardkleuren",
    editorTitle: "Kleurenpalet van dashboard aanpassen",
    brushTooltip: "Kleuren aanpassen",
    hexModeCheckbox: "HEX handmatig invoeren",
    closeAriaLabel: "Kleurenpalet-editor sluiten",
    swatchLabels: {
      canvasBg: "Dashboardachtergrond",
      subheaderBg: "Dashboardkoptekst",
      textPrimary: "Primaire dashboardtekst",
      textSecondary: "Secundaire dashboardtekst",
      widgetsBg: "Widgetachtergrond",
      border: "Widgetrand",
      borderHover: "Widgetrand bij hover",
      widgetTitle: "Widgettitel",
      widgetPrimary: "Primaire widgettekst",
      widgetSecondary: "Secundaire widgettekst",
    },
    swatchDescriptions: {
      canvasBg: "Achtergrondkleur van dashboard",
      subheaderBg: "Achtergrondkleur van dashboardkoptekst",
      textPrimary: "Kleur van primaire dashboardtekst",
      textSecondary: "Kleur van secundaire dashboardtekst",
      widgetsBg: "Achtergrondkleur van widget",
      border: "Randkleur van widget",
      borderHover: "Randkleur van widget bij hover",
      widgetTitle: "Kleur van widgettitel",
      widgetPrimary: "Kleur van primaire widgettekst",
      widgetSecondary: "Kleur van secundaire widgettekst",
    },
    popoverTitles: {
      canvasBg: "Kies dashboardachtergrond",
      subheaderBg: "Kies dashboardkoptekst",
      textPrimary: "Kies primaire dashboardtekst",
      textSecondary: "Kies secundaire dashboardtekst",
      widgetsBg: "Kies widgetachtergrond",
      border: "Kies widgetrand",
      borderHover: "Kies widgetrand bij hover",
      widgetTitle: "Kies widgettitel",
      widgetPrimary: "Kies primaire widgettekst",
      widgetSecondary: "Kies secundaire widgettekst",
    },
  },
};

export const dashboardThemeEditorTr = {
  [moduleNameKey]: {
    brushTooltip: "Renkleri özelleştirin",
    closeAriaLabel: "Palet düzenleyiciyi kapat",
    editorTitle: "Kontrol Paneli renk paletini özelleştirin",
    hexModeCheckbox: "HEX'i manuel olarak yazın",
    popoverTitles: {
      border: "Widget kenarlığını seçin",
      borderHover: "Fareyle üzerine gelindiğinde widget kenarlığını seçin",
      canvasBg: "Kontrol paneli arka planını seçin",
      subheaderBg: "Kontrol paneli başlığını seçin",
      textPrimary: "Kontrol paneli birincil metnini seçin",
      textSecondary: "Kontrol paneli ikincil metnini seçin",
      widgetPrimary: "Widget birincil metnini seçin",
      widgetsBg: "Widget arka planını seçin",
      widgetSecondary: "Widget ikincil metnini seçin",
      widgetTitle: "Widget başlığını seçin",
    },
    resetPalette: "Varsayılan renkler",
    swatchDescriptions: {
      border: "Widget kenarlık rengi",
      borderHover: "Fareyle üzerine gelindiğinde widget kenarlığı rengi",
      canvasBg: "Kontrol paneli arka plan rengi",
      subheaderBg: "Kontrol paneli başlığı arka plan rengi",
      textPrimary: "Kontrol paneli birincil metin rengi",
      textSecondary: "Kontrol paneli ikincil metin rengi",
      widgetPrimary: "Widget'ın birincil metin rengi",
      widgetsBg: "Widget arka plan rengi",
      widgetSecondary: "Widget ikincil metin rengi",
      widgetTitle: "Widget başlığı metin rengi",
    },
    swatchLabels: {
      border: "Widget sınırı",
      borderHover: "Widget kenarlığının üzerine gelinmesi",
      canvasBg: "Kontrol paneli arka planı",
      subheaderBg: "Kontrol Paneli Başlığı",
      textPrimary: "Kontrol Paneli Birincil metni",
      textSecondary: "Kontrol Paneli İkincil metin",
      widgetPrimary: "Widget birincil metni",
      widgetsBg: "Widget arka planı",
      widgetSecondary: "Widget ikincil metni",
      widgetTitle: "Widget başlığı",
    },
  },
};
